/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetQuestionsRequest, TGetQuestionsModel, IMappers, TGetQuestionsResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetQuestionsWebResponse } from '../../entities/get_questions_web/GetQuestionsWebResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetQuestionsModel(parameters: TGetQuestionsRequest): TGetQuestionsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-reviews',
    pathApi: '/v1/get-questions/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetQuestionsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetQuestionsRequest;
}

export async function fetchGetQuestions<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetQuestionsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetQuestionsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetQuestionsModel(parameters),
    config,
  )) as FetchResponse<TGetQuestionsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetQuestionsWebResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetQuestionsResponse>;
}
